import { useTranslate } from '@ur-solutions/react-hooks'
import { Diet } from './DietCell'
import styled from 'styled-components'
import type { DriverDietNode } from '@/modules/activities/types.graphql'

const TextAndAction = styled.div<{ border?: boolean }>`
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  border-radius: ${props => props.theme.standardBorderRadius};
  border: ${props =>
    props.border ? `1px solid ${props.theme.colors.gray9}` : 'none'};
  background-color: ${props => props.theme.colors.white};

  & > *:first-child {
    border-right: 1px solid ${props => props.theme.colors.gray9};
    margin-right: 1rem;
    padding-right: 1rem;
  }
  & > *:last-child {
    cursor: pointer;
  }
  ${props => props.theme.media.mobile} {
    width: 100%;
  }
`

export const DietTextAndAction: React.FC<{
  diet: Pick<
    DriverDietNode,
    'partOfDay' | 'salaryCode' | 'isManuallyEdited'
  > | null
  canEdit?: boolean
  border?: boolean
  restrictWidth?: boolean
  onClick: () => void
}> = ({ diet, canEdit, border, restrictWidth, onClick }) => {
  const translations = useTranslate({
    diet: 'common.diet',
  })

  return (
    <TextAndAction border={border} onClick={onClick}>
      <div>{translations.diet}</div>
      <Diet
        diet={diet}
        canEdit={canEdit ?? false}
        onClick={onClick}
        restrictWidth={restrictWidth}
      />
    </TextAndAction>
  )
}
